
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";

    interface State {
        sealType: string; // 是否有闲鱼优品印章
        carModel: string;
        vin: string;
        mileage: string;
        year: string;
    }

    export default defineComponent({
        name: "reportCarInfo",
        setup() {
            let state: State = reactive({
                sealType: 'xianyu',
                carModel: '',
                vin: '',
                mileage: '',
                year: ''
            })
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo,(data: any) => {
                const {modelName, vin, carRegDate, mileage} = data;
                state.vin = vin;
                state.carModel = modelName;
                state.mileage = mileage;
                state.year = carRegDate + '年';
            })
            return {
                state
            }
        },
        methods: {}
    })
